import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const listingReportSlice = createSlice({
    name: "listingReport",
    initialState: {
        page: 0,
        pageCount: 0,
        total: 0,
        listData: null,
        detailData: null,
        errorDetailData: null,
    },
    reducers: {
        doGetReportListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload.current_page;
            state.pageCount = action.payload.page_count;
            state.total = action.payload.total_row;
        },
        doGetReportListFail: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.total = 0;
        },
        doGetReportDetailSuccess: (state, action) => {
            state.detailData = action.payload.report;
        },
        doGetReportDetailFail: (state, action) => {
            state.detailData = null;
            state.errorDetailData = action.payload;
        },
        resetListingReportState: (state) => {
            state.errorDetailData = null;
        },
        resetListingReportDetailState: (state) => {
            state.detailData = null;
            state.errorDetailData = null;
        },
    },
});

const buildReportQuery = (param = {}) => {
    const q = [];
    if (param.page != null) q.push(`page=${param.page}`);
    if (param.limit != null) q.push(`size=${param.limit}`);
    if (param.keyword) q.push(`keyword=${encodeURIComponent(param.keyword)}`);
    if (param.reason) q.push(`reason=${param.reason}`);
    if (param.created_from) q.push(`created_from=${param.created_from}`);
    if (param.created_to) q.push(`created_to=${param.created_to}`);
    if (param.sort_by) q.push(`sort_by=${param.sort_by}`);
    return q.length ? `?${q.join("&")}` : "";
};

export const doGetReportList = (param) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/listing-reports${buildReportQuery(param)}`);
        dispatch(doGetReportListSuccess(response.data));
    } catch (error) {
        dispatch(doGetReportListFail(error.response));
    }
};

export const doGetReportDetail = (param) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/listing-reports/${param.report_id}`);
        dispatch(doGetReportDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetReportDetailFail(error.response));
    }
};

export const {
    doGetReportListSuccess,
    doGetReportListFail,
    doGetReportDetailSuccess,
    doGetReportDetailFail,
    resetListingReportState,
    resetListingReportDetailState,
} = listingReportSlice.actions;

export const getReportList = (state) => state.listingReport?.listData;
export const getReportListPage = (state) => state.listingReport?.page;
export const getReportListPageCount = (state) => state.listingReport?.pageCount;
export const getReportListTotal = (state) => state.listingReport?.total;
export const getReportDetail = (state) => state.listingReport?.detailData;
export const getReportErrorDetailData = (state) => state.listingReport?.errorDetailData;

export default listingReportSlice.reducer;
